// extracted by mini-css-extract-plugin
export var eyebrow = "_hs-3";
export var heroImage = "_hs-4";
export var main = "_hs-2";
export var modal = "_hs-0";
export var shell = "_hs-1";